export default __webpack_public_path__ + "static/media/ellipse30.34b2de40.svg";